export default class InputValidator {
    constructor() {
        this.forbiddenDni = ['11111111H', '22222222J', '33333333P', '44444444A', '55555555K', '66666666Q', '77777777B', '88888888Y', '99999999R'];
        this.maxIbanLength = 34;
        this.ibanLengths = {
            AL: 28, AD: 24, AT: 20, AZ: 28, BH: 22, BE: 16, BA: 20, BR: 29, BG: 22, CR: 22, HR: 21, CY: 28, CZ: 24,
            DK: 18, DO: 28, EE: 20, FO: 18, FI: 18, FR: 27, GE: 22, DE: 22, GI: 23, GR: 27, GL: 18, GT: 28, HU: 28,
            IS: 26, IE: 22, IL: 23, IT: 27, JO: 30, KZ: 20, KW: 30, LV: 21, LB: 28, LI: 21, LT: 20, LU: 20, MK: 19,
            MT: 31, MR: 27, MU: 30, MD: 24, MC: 27, ME: 22, NL: 18, NO: 15, PK: 24, PS: 29, PL: 28, PT: 25, QA: 29,
            RO: 24, SM: 27, SA: 24, RS: 22, SK: 24, SI: 19, ES: 24, SE: 24, CH: 21, TN: 24, TR: 26, AE: 23, GB: 22,
            VG: 24
        };
        this.bankSwiftMap = {
            ES: { // Spain
                '2100': 'CAIXESBBXXX',
                '0049': 'BSCHESMMXXX',
                '0182': 'BBVAESMMXXX',
                '0128': 'BKBKESMMXXX'
            },
            DE: { // Germany
                '10010010': 'PBNKDEFF',
                '37040044': 'COBADEFFXXX'
            },
            FR: { // France
                '30004': 'BNPAFRPP',
                '20041': 'SOGEFRPP'
            }
        };
    }

    initializeErrorMsg(type, input) {
        let errorMsgDiv = document.createElement('div');
        errorMsgDiv.setAttribute('data-entity', type);
        errorMsgDiv.classList.add('custom-error', 'mt-1');
        input.parentNode.insertBefore(errorMsgDiv, input.nextSibling);
    }

    validateEmail(errorContainer, input, errorMsg) {
        let value = input.value;

        if (value === "" || !value.match(this.getEmailValidatorRegExp())) {
            input.classList.add('border-error');
            if (errorMsg && errorContainer) {
                errorContainer.innerHTML = errorMsg;
                errorContainer.classList.add('fadeIn');
            }
            return false;
        }

        if (errorContainer) {
            errorContainer.classList.remove('fadeIn');
        }
        input.classList.remove('border-error');
        return true;
    }

    getEmailValidatorRegExp() {
        return "^[a-zA-Z0-9_-]+([.][a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+([.][a-zA-Z0-9_-]+)*[.][a-zA-Z]{2,4}$";
    }

    validateDateFormat(errorContainer, input, errorMsg) {
        let value = input.value;

        if (value === "" || !value.match(this.getDateFormatValidatorRegExp())) {
            input.classList.add('border-error');
            if (errorMsg && errorContainer) {
                errorContainer.innerHTML = errorMsg;
                errorContainer.classList.add('fadeIn');
            }
            return false;
        }

        if (errorContainer) {
            errorContainer.classList.remove('fadeIn');
        }
        input.classList.remove('border-error');
        return true;
    }

    getDateFormatValidatorRegExp() {
        return "((0[1-9]|1[0-9]|2[0-9]|3[01])/(0[1-9]|1[012])/[0-9]{4})|([A-Za-z]{2}/[A-Za-z]{2}/[A-Za-z]{4})";
    }

    validateEmpty(input) {
        const value = input.value;
        if (value === "" || value === undefined) {
            input.classList.add('border-error');
            return false;
        }
        if (input.type === 'select-one') {
            return this.validateDisabledSelect(input);
        }
        input.classList.remove('border-error');
        return true;
    }

    validateDisabledSelect(input) {
        return Array.from(input.querySelectorAll('option')).find((o) => o.value === input.value).disabled !== true;
    }

    validateNumber(input) {
        const minValue = Number.parseInt(input.getAttribute('data-min-value'));
        const maxValue = Number.parseInt(input.getAttribute('data-max-value'));
        return !Number.isNaN(input.value) && (
            Number.parseInt(input.value) >= (minValue ? minValue : 0) &&
            Number.parseInt(input.value) <= (maxValue ? maxValue : Number.MAX_VALUE));
    }

    validateTextAlphabetic(input) {
        const textRegex = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\\\\s_ ]*)$/;
        return textRegex.test(input.value);
    }

    validateIsChecked(input) {
        return input.checked;
    }

    validateFileSize(input) {
        const maxSize = Number.parseInt(input.getAttribute('data-max-size'))
        return !Array.from(input.files).some((file) => {
            let mb = (file.size / 1024 / 1024) * 1.049;
            return mb > maxSize;
        });
    }

    validateFileExtension(input) {
        const validExtensions = input.getAttribute('data-valid-extensions').split(',');
        return !Array.from(input.files).some((file) => {
            return !validExtensions.includes(file.name.split('.').pop());
        });
    }

    validateFileEmpty(input) {
        return Array.from(input.files).length !== 0;
    }

    validateDni(input) {
        const dni = input.value;
        return this.validateDniValue(dni) || this.validateNieValue(dni) || this.validateCifValue(dni);
    }

    validateBirthday(input) {
        const birthday = input.value;
        return this.isValidBirthday(birthday);
    }

    validateNie(input) {
        const nie = input.value;
        return this.validateNieValue(nie);
    }

    validateCif(input) {
        const cif = input.value;
        return this.validateCifValue(cif);
    }

    validateDniValue(dni) {
        const dniRegex = /^[0-9]{8}[a-zA-Z]$/;
        if (!dniRegex.test(dni)) {
            return false;
        }

        const letters = "TRWAGMYFPDXBNJZSQVHLCKE";
        const number = parseInt(dni.slice(0, 8), 10);
        const letter = dni.charAt(8);
        return (letters.charAt(number % 23) === letter || letters.charAt(number % 23).toLowerCase() === letter) && this.forbiddenDni.indexOf(dni) === -1;
    }

    isValidBirthday(dateStr) {
        const date = this.parseDate(dateStr);
        const today = new Date();

        if (isNaN(date.getTime())) {
            return false;
        }

        if (date > today) {
            return false;
        }

        return true;
    }

    parseDate(dateStr) {
        const [day, month, year] = dateStr.split('/').map(Number);
        return new Date(year, month - 1, day);
    }

    validateNieValue(nie) {
        const nieRegex = /^[XYZ][0-9]{7}[A-Z]$/;
        if (!nieRegex.test(nie)) {
            return false;
        }

        const letters = "TRWAGMYFPDXBNJZSQVHLCKE";
        let number = nie.slice(1, 8);
        const letter = nie.charAt(8);

        switch (nie.charAt(0)) {
            case 'X':
                number = '0' + number;
                break;
            case 'Y':
                number = '1' + number;
                break;
            case 'Z':
                number = '2' + number;
                break;
        }

        return letters.charAt(parseInt(number, 10) % 23) === letter;
    }

    validateCifValue(cif) {
        const cifRegex = /^[ABCDEFGHJKLMNPQRSUVW][0-9]{7}[0-9A-J]$/;
        if (!cifRegex.test(cif)) {
            return false;
        }

        const control = cif.charAt(8);
        const digits = cif.slice(1, 8);
        let sum = 0;

        for (let i = 0; i < digits.length; i++) {
            let digit = parseInt(digits[i], 10);
            if (i % 2 === 0) {
                digit *= 2;
                if (digit > 9) {
                    digit -= 9;
                }
            }
            sum += digit;
        }

        const controlDigit = (10 - (sum % 10)) % 10;
        const controlLetter = "JABCDEFGHI"[controlDigit];

        if (/\d/.test(control)) {
            return parseInt(control, 10) === controlDigit;
        } else {
            return control === controlLetter;
        }
    }

    formatIban(value) {
        return value.replace(/[^A-Z0-9]/gi, '').replace(/(.{4})/g, '$1 ').trim();
    }

    autoFillSwift(iban) {
        const cleanIban = iban.replace(/\s+/g, '').toUpperCase();
        const country = cleanIban.slice(0, 2);
        let bankCode;

        if (country === 'ES') bankCode = cleanIban.slice(4, 8);
        else if (country === 'DE') bankCode = cleanIban.slice(4, 12);
        else if (country === 'FR') bankCode = cleanIban.slice(4, 9);

        return this.bankSwiftMap[country]?.[bankCode] || '';
    };

    cleanIbanInput(value) {
        return value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    }

    validateIban(ibanInput, swiftInput = null) {
        const iban = ibanInput.value.trim();
        if (!iban) {
            return true;
        }
        let cleanValue = this.cleanIbanInput(ibanInput.value);
        const countryCode = cleanValue.slice(0, 2);
        const maxLength = this.ibanLengths[countryCode] || this.maxIbanLength;

        if (cleanValue.length > maxLength) {
            cleanValue = cleanValue.slice(0, maxLength);
        }

        ibanInput.value = this.formatIban(cleanValue);
        const isValid = this.validateIbanValue(cleanValue);

        if (isValid && swiftInput) {
            const autofillSwiftValue = this.autoFillSwift(cleanValue);
            if (autofillSwiftValue && swiftInput.value.trim() === "") {
                swiftInput.value = autofillSwiftValue;
            }
        }

        return isValid;
    }

    validateIbanValue(iban) {
        if (iban.length < 4) return false;
        const country = iban.slice(0, 2);

        if (!this.ibanLengths[country]) return false;
        if (iban.length !== this.ibanLengths[country]) return false;

        const rearranged = iban.slice(4) + iban.slice(0, 4);
        let remainder = rearranged.replace(/[A-Z]/g, ch => ch.charCodeAt(0) - 55);

        while (remainder.length > 2) {
            const block = remainder.slice(0, 9);
            remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
        }
        return parseInt(remainder, 10) % 97 === 1;
    }

    validateSwift(swiftInput) {
        if (!swiftInput || !swiftInput.value) {
            return true; // No validation needed if input is empty
        }

        // BIC/SWIFT length btw 8 and 11
        const swift = swiftInput.value.trim().toUpperCase();
        const regex = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

        if (!(swift.length === 8 || swift.length === 11)) {
            return false;
        }

        return regex.test(swift);
    }
}
